import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, MapPin, Phone, Mail, Clock } from "lucide-react";
import { CONTACT } from "../mock";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [signed, setSigned] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await fetch("https://formsubmit.co/ajax/hangzensurfschool@gmail.com", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          email,
          _subject: "New Hang Zen Newsletter Signup",
          _template: "table",
          _captcha: "false",
          form_type: "Newsletter Signup",
        }),
      });
    } catch (_) {}
    setSigned(true);
    setEmail("");
    setTimeout(() => setSigned(false), 4000);
  };

  return (
    <footer className="bg-slate-900 text-slate-200">
      {/* Newsletter band */}
      <div className="bg-gradient-to-r from-amber-400 to-orange-500">
        <div className="max-w-6xl mx-auto px-6 py-12 grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h3
              className="text-3xl md:text-4xl text-slate-900 mb-2"
              style={{ fontFamily: "'Pacifico', cursive" }}
            >
              Join the Hang Zen Crew
            </h3>
            <p className="text-slate-800/90">
              Swell forecasts, fish counts, kids camp dates and retreat details. No spam — just ocean updates.
            </p>
          </div>
          <form onSubmit={onSubmit} className="flex gap-2">
            <input
              type="email"
              required
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1 px-4 py-3 rounded-full bg-white text-slate-800 placeholder-slate-400 outline-none focus:ring-2 focus:ring-slate-900"
            />
            <button
              type="submit"
              className="px-6 py-3 bg-slate-900 hover:bg-slate-800 text-white font-semibold rounded-full transition-colors"
            >
              {signed ? "Aloha!" : "Sign Up"}
            </button>
          </form>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="mb-4">
            <img src="/logo.png" alt="Hang Zen Surf + Sea" className="h-32 w-auto" />
          </div>
          <p className="text-slate-400 max-w-md mb-5">
            Surf lessons, fishing charters, jet ski adventures, sunset cruises and more — based in the surfing Mecca of Leucadia, Encinitas, California.
          </p>
          <div className="flex gap-3">
            <a
              href={CONTACT.facebook}
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
              className="w-10 h-10 rounded-full bg-slate-800 hover:bg-orange-500 flex items-center justify-center transition-colors"
            >
              <Facebook size={18} />
            </a>
            <a
              href={CONTACT.instagram}
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
              className="w-10 h-10 rounded-full bg-slate-800 hover:bg-orange-500 flex items-center justify-center transition-colors"
            >
              <Instagram size={18} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 uppercase text-xs tracking-widest">
            Contact
          </h4>
          <ul className="space-y-3 text-sm text-slate-400">
            <li className="flex gap-2">
              <MapPin size={16} className="shrink-0 mt-0.5 text-orange-400" />
              <a
                href={`https://maps.google.com/?q=${encodeURIComponent(CONTACT.address)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition-colors"
                data-testid="footer-address-link"
              >
                {CONTACT.address}
              </a>
            </li>
            <li className="flex gap-2">
              <Phone size={16} className="shrink-0 mt-0.5 text-orange-400" />
              <a href={`tel:${CONTACT.phoneRaw}`} className="hover:text-white">
                {CONTACT.phone}
              </a>
            </li>
            <li className="flex gap-2">
              <Mail size={16} className="shrink-0 mt-0.5 text-orange-400" />
              <a href={`mailto:${CONTACT.email}`} className="hover:text-white">
                {CONTACT.email}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 uppercase text-xs tracking-widest flex items-center gap-2">
            <Clock size={14} /> Hours
          </h4>
          <ul className="space-y-1.5 text-sm text-slate-400">
            {CONTACT.hours.map((h) => (
              <li key={h.day} className="flex justify-between">
                <span className="text-slate-300">{h.day}</span>
                <span>{h.time}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row justify-between items-center gap-3 text-sm text-slate-500">
          <div>© {new Date().getFullYear()} Hang Zen Surf + Sea — All Rights Reserved.</div>
          <div className="flex gap-5">
            <Link to="/about-us" className="hover:text-white">About</Link>
            <Link to="/gallery" className="hover:text-white">Gallery</Link>
            <Link to="/book-today" className="hover:text-white">Book</Link>
            <Link to="/waiver" className="hover:text-white" data-testid="footer-waiver-link">Waiver</Link>
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-6 pb-5 text-center text-xs text-slate-500">
          Website Created by{" "}
          <a
            href="https://www.GregMiceli.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white underline-offset-2 hover:underline"
            data-testid="footer-credit-link"
          >
            www.GregMiceli.com
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
